import React, { Component } from 'react';

import { Loader } from 'components/loader';
import 'configs/styles/certificate-fonts.css';
import { allHasSameProp } from 'helpers/Object';
import isEmpty from 'lodash/isEmpty';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import ConfigService from 'modules/configManager/ConfigService';
import { FeatureToggles } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import CanvasImages from '../image/CanvasImages';
import CanvasAlign from '../object/CanvasAlign';
import CanvasColor from '../object/CanvasColor';
import CanvasLayerOrder from '../object/CanvasLayerOrder';
import CanvasAddText from '../text/CanvasAddText';
import CanvasMergedTags from '../text/CanvasMergedTags';
import CanvasTextAlign from '../text/CanvasTextAlign';
import CanvasTextFontFamily from '../text/CanvasTextFontFamily';
import CanvasTextFontStyle from '../text/CanvasTextFontStyle';
import CanvasTextFontWeight from '../text/CanvasTextFontWeight';
import CanvasTextSize from '../text/CanvasTextSize';

import './CanvasMenu.scss';

@inject((stores) => ({
  storeCertificate: stores.ConfigStore.certificate,
  isQrCodeEnabled: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.CertificateQrCode
  )
}))
export default class CanvasMenu extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    setLoader: PropTypes.func,
    storeCertificate: MobxPropTypes.objectOrObservableObject,
    isQrCodeEnabled: PropTypes.bool,
    onAddQrCode: PropTypes.func
  };

  state = {
    actualTag: '',
    fontWeight: false,
    fontStyle: false,
    fontSize: null,
    fontFamily: null,
    addingText: false,
    textAlign: null,
    tag: null,
    loading: false
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.canvasRef && this.props.canvasRef) {
      this.updateMenu();
      this.props.canvasRef.on({
        'selection:created': this.updateMenu,
        'selection:cleared': this.updateMenu,
        'selection:updated': this.updateMenu
      });
    }
  }

  updateHasChangeOnTempalte = () => {
    const { hasChangeOnTemplate } = this.props.storeCertificate;

    if (!hasChangeOnTemplate) {
      ConfigService.setCertificateData({ hasChangeOnTemplate: true });
    }
  };

  updateMenu = () => {
    const { canvasRef } = this.props;

    canvasRef.defaultCursor = 'default';
    const activeObjects = canvasRef.getActiveObjects();

    this.updateMenuState(activeObjects, 'fontStyle', 'italic');
    this.updateMenuState(activeObjects, 'fontWeight', 'bold');
    this.updateMenuValue(activeObjects, 'fontSize');
    this.updateMenuValue(activeObjects, 'fontFamily');
    this.updateMenuValue(activeObjects, 'textAlign');
    this.setState({ tag: null, addingText: false });
  };

  updateMenuValue(activeObjects, prop) {
    const obj = {};
    const objectsHasEqualProp =
      !isEmpty(activeObjects) &&
      allHasSameProp(activeObjects[0][prop], prop, activeObjects);

    if (objectsHasEqualProp) {
      obj[prop] = activeObjects[0][prop];
    } else {
      obj[prop] = null;
    }
    this.setState(obj);
  }

  updateMenuState(activeObjects, prop, value) {
    const obj = {};

    if (!isEmpty(activeObjects)) {
      obj[prop] = allHasSameProp(value, prop, activeObjects);
    } else {
      obj[prop] = false;
    }
    this.setState(obj);
  }

  updateAddText() {
    this.setState({ addingText: !this.state.addingText });
    this.updateHasChangeOnTempalte();
  }

  updateMergeTag(option) {
    const actualTag = { value: option.key, label: option.value };

    this.setState({ tag: option, actualTag });
    this.updateHasChangeOnTempalte();
  }

  setLoader = (value = false) => {
    const { loading } = this.state;

    if (loading !== value) {
      this.setState({ loading: value });
    }
  };

  render() {
    const { canvasRef, setLoader, isQrCodeEnabled, onAddQrCode } = this.props;

    const {
      textAlign,
      fontSize,
      fontFamily,
      fontStyle,
      fontWeight,
      tag,
      actualTag,
      addingText,
      loading
    } = this.state;

    return (
      <div className="canvas-editor__menu">
        <CanvasImages
          canvasRef={canvasRef}
          onLoading={setLoader}
          updateInfo={this.updateHasChangeOnTempalte}
        />

        <CanvasAddText
          canvasRef={canvasRef}
          onUpdate={this.updateAddText.bind(this)}
          addingText={addingText}
        />

        <CanvasTextFontWeight
          canvasRef={canvasRef}
          onUpdate={this.updateMenu}
          updateInfo={this.updateHasChangeOnTempalte}
          isAllBold={fontWeight}
        />

        <CanvasTextFontStyle
          canvasRef={canvasRef}
          onUpdate={this.updateMenu}
          updateInfo={this.updateHasChangeOnTempalte}
          isAllItalic={fontStyle}
        />

        <CanvasTextFontFamily
          canvasRef={canvasRef}
          onUpdate={this.updateMenu}
          updateInfo={this.updateHasChangeOnTempalte}
          fontFamily={fontFamily}
        />

        <CanvasTextSize
          canvasRef={canvasRef}
          onUpdate={this.updateMenu}
          updateInfo={this.updateHasChangeOnTempalte}
          fontSize={fontSize}
        />

        <CanvasColor
          canvasRef={canvasRef}
          updateInfo={this.updateHasChangeOnTempalte}
        />

        <CanvasTextAlign
          canvasRef={canvasRef}
          onUpdate={this.updateMenu}
          updateInfo={this.updateHasChangeOnTempalte}
          textAlign={textAlign}
        />

        <CanvasLayerOrder
          canvasRef={canvasRef}
          updateInfo={this.updateHasChangeOnTempalte}
        />

        <CanvasAlign
          canvasRef={canvasRef}
          updateInfo={this.updateHasChangeOnTempalte}
        />

        <CanvasMergedTags
          isQrCodeEnabled={isQrCodeEnabled}
          canvasRef={canvasRef}
          onUpdate={this.updateMergeTag.bind(this)}
          onAddQrCode={onAddQrCode}
          tag={tag}
          actualTag={actualTag}
        />

        {loading && (
          <Loader key="loader" mask className="canvas-editor__loader" />
        )}
      </div>
    );
  }
}
